import { CM, Tction } from '@tkit/model';
import { TkitUtils as Utils } from '@tkit/types';
import { message } from 'antd';
import {
  APIS,
  ParamsgroupsAllUsingGet,
  PageableResultGroupVO,
  ParamsBodygroupsUsingPost,
  ParamsBodygroupsGroupIdUsingPut,
  ParamsgroupsUsingDelete,
  ParamsBodygroupsGroupIdAddMemberUsingPut
} from '@src/services';

export interface State {
  groupsModel: PageableResultGroupVO;
}

export const groupModelState: State = {
  groupsModel: {}
};

const model = CM({
  state: groupModelState,
  namespace: 'groupModel',
  reducers: {
    /** doSomething */
    setGroupList: (state, action: Tction<PageableResultGroupVO>) => {
      return {
        ...state,
        groupsModel: action.payload
      };
    }
  },
  effects: {
    /**
     * @description 获取圈子列表
     */
    *getGropuListAsyc(
      { tPut, tCall },
      action: Tction<ParamsgroupsAllUsingGet>
    ): Iterator<{}, any, any> {
      const data: Utils.GetROA<typeof APIS.GroupApi.groupsAllUsingGet> = yield tCall(
        APIS.GroupApi.groupsAllUsingGet,
        action.payload
      );

      if (data.code === 0 && data.result) {
        yield tPut(model.actions.setGroupList, data.result);
      }
    },
    /**
     * @description 新增圈子
     */
    *addGorupAsyc(
      { tPut, tCall },
      action: Tction<{ params: ParamsBodygroupsUsingPost; callback?: () => void }>
    ): Iterator<{}, any, any> {
      const { params, callback } = action.payload;
      const data: Utils.GetROA<typeof APIS.GroupApi.groupsUsingPost> = yield tCall(
        APIS.GroupApi.groupsUsingPost,
        params
      );

      if (data.code === 0) {
        callback && callback();
      } else {
        message.error(data.message);
      }
    },
    /**
     * @description 编辑圈子
     */
    *editGorupAsyc(
      { tPut, tCall },
      action: Tction<{ params: ParamsBodygroupsGroupIdUsingPut; callback?: () => void }>
    ): Iterator<{}, any, any> {
      const { params, callback } = action.payload;
      const data: Utils.GetROA<typeof APIS.GroupApi.groupsGroupIdUsingPut> = yield tCall(
        APIS.GroupApi.groupsGroupIdUsingPut,
        params
      );

      if (data.code === 0) {
        callback && callback();
      } else {
        message.error(data.message);
      }
    },
    /**
     * @description 删除圈子
     */
    *deleteGorupAsyc(
      { tPut, tCall },
      action: Tction<{ params: ParamsgroupsUsingDelete; callback?: () => void }>
    ): Iterator<{}, any, any> {
      const { params, callback } = action.payload;
      const data: Utils.GetROA<typeof APIS.GroupApi.groupsUsingDelete> = yield tCall(
        APIS.GroupApi.groupsUsingDelete,
        params
      );

      if (data.code === 0) {
        callback && callback();
      } else {
        message.error(data.message);
      }
    },

    /** 添加成员 */
    *addMemberAsyc(
      { tPut, tCall },
      action: Tction<{ data: ParamsBodygroupsGroupIdAddMemberUsingPut }>
    ): Iterator<{}, any, any> {
      const { data } = action.payload;
      const res: Utils.GetROA<typeof APIS.GroupApi.groupsGroupIdAddMemberUsingPut> = yield tCall(
        APIS.GroupApi.groupsGroupIdAddMemberUsingPut,
        data
      );
      if (res.code === 0) {
        message.success('添加成功');
      } else {
        message.error(res.message);
      }
    }
  }
});

/**
 * @description 全局Model groupModel 挂载到 redux 上
 */
export default model;
